import { render, staticRenderFns } from "./riskGyssj.vue?vue&type=template&id=2ba1a8a0&scoped=true&"
import script from "./riskGyssj.vue?vue&type=script&lang=js&"
export * from "./riskGyssj.vue?vue&type=script&lang=js&"
import style0 from "./riskGyssj.vue?vue&type=style&index=0&id=2ba1a8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1a8a0",
  null
  
)

export default component.exports